import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const formatAttenderField = attenderField => {
  return attenderField.trim().toLowerCase();
};
export const getGTMUserData = bookingAttendersData => {
  return {
    user_data: _objectSpread({
      address: {
        first_name: formatAttenderField(bookingAttendersData.firstName),
        last_name: formatAttenderField(bookingAttendersData.lastName)
      },
      email_address: formatAttenderField(bookingAttendersData.email)
    }, !!(bookingAttendersData !== null && bookingAttendersData !== void 0 && bookingAttendersData.phone) && {
      phone_number: formatAttenderField(bookingAttendersData.phone)
    })
  };
};